module.exports = __webpack_public_path__ + "img/master_card.4050f1e7.webp";